import React from 'react'
import EcoProButton from '../../../../../shared/button/button'
import './HardwareInclusiveModalCard.css'
import { useTranslation } from 'react-i18next'

function HardwareInclusiveModalCard(props) {
    const { title, price, info, description, image, onModalSelect, value } = props
    const { t } = useTranslation(["translation"])
    return (
        <div className='cp-modal-card-wrapper'>
            {image &&
                <div className='cp-modal-card-img-wrapper'>
                    <img src={image} alt={info} />
                </div>
            }
            <div className='cp-modal-card-content-wrapper'>
                <div className='title'>
                    <div>{title}</div>
                    {price}
                </div>
                <div className='description'>
                    <div>{info}</div>
                    {description && <div className='description-content'>{description}</div>}
                </div>
                <div>
                    <EcoProButton
                        cname="pcb-select"
                        btnID={value?.toString()}
                        onBtnClick={() => onModalSelect(value)}
                    >
                        {t("HARDWARE_SIGNUP.BUTTON.SELECT")}
                    </EcoProButton>
                </div>
            </div>
        </div>
    )
}

export default HardwareInclusiveModalCard